import { render } from "./NoticeBoard.vue?vue&type=template&id=07b3feda&scoped=true"
import script from "./NoticeBoard.vue?vue&type=script&lang=js"
export * from "./NoticeBoard.vue?vue&type=script&lang=js"

import "./NoticeBoard.vue?vue&type=style&index=0&id=07b3feda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b3feda"]])

export default __exports__